// extracted by mini-css-extract-plugin
export var changeIcon = "_4u-4";
export var container = "_4u-0";
export var divider = "_4u-7";
export var externalLinkIcon = "_4u-1";
export var green = "_4u-5";
export var helpCircleIcon = "_4u-3";
export var iconButton = "_4u-2";
export var red = "_4u-6";